import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { toast } from 'angular2-materialize';
import { AuthService } from '../../services/auth.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { PermissionService } from '../../services/permission.service';
import { ProductionOrderId, ProductionOrderService } from '../../services/production-order.service';

@Component({
  selector: 'app-odp-lite-search',
  templateUrl: './odp-lite-search.component.html',
  styleUrls: ['./odp-lite-search.component.css']
})
export class OdpLiteSearchComponent implements OnInit {
  allowed: boolean = false;
  loaded: boolean = false;

  constructor(
    private service: ProductionOrderService,
    private firestoreServide: FirestoreService,
    private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      let permission = this.permissionService.constructPermissionObject(groups, this.service.collection);
      if(!permission || !permission.readAction){
        toast('No tiene permisos de lectura.', 2000);
        this.router.navigate(['/']);
      }else{
        this.allowed = true;
        this.onInit();
      }
    });
  }

  limit: number = 20;
  folio: string = '';
  odps: ProductionOrderId[] = [];

  ngOnInit() {
  }
  async onInit(){
    let odps: ProductionOrderId[] = await this.firestoreServide.colWithIds<ProductionOrderId>( this.service.collection, ref => ref.orderBy('projectFolio', 'desc').where('active', '==', 1).limit(this.limit) );
    /* let odps: ProductionOrderId[] = [];
    await new Promise<void>(resolve => {
      let sub = this.firestoreServide.colWithIds$( this.service.collection, ref => ref.orderBy('projectFolio', 'desc').where('active', '==', 1).limit(15) ).subscribe(fsOdps => {
        sub.unsubscribe();
        odps = fsOdps;
        resolve();
      });
    }); */
    //window['odps'] = odps;
    this.odps = odps;
    this.loaded = true;
  }

  async onSearch(){
    let odps = await this.firestoreServide.colWithIds<ProductionOrderId>( this.service.collection, ref => ref.where('active', '==', 1).where('name', '==', this.folio.toUpperCase()) );
    /* let odps: ProductionOrderId[] = [];
    await new Promise<void>(resolve => {
      let sub = this.firestoreServide.colWithIds$( this.service.collection, ref => ref.where('active', '==', 1).where('name', '==', this.folio.toUpperCase()) ).subscribe(fsOdps => {
        sub.unsubscribe();
        odps = fsOdps;
        resolve();
      });
    }); */
    if(odps[0]){
      this.onView(odps[0].id);
    }else{
      toast('No se encontró una orden con ese folio', 3000);
    }
  }

  onView(id: string){
    this.service.returnFromViewTo = 'lite';
    this.service.windowReplace('view', id);
  }

}
